"use client";

import { css, styled } from "styled-components";

import {
  poppins_body_sm_medium,
  ptSerif_body_sm_regular,
} from "@frontend/design-system";

export const ZoomControls = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;
  flex-shrink: 0;
`;

export const ZoomContents = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-shrink: 0;
`;

export const ZoomBtn = styled.button<{ $disabled?: boolean }>`
  box-sizing: border-box;
  width: 2.4rem;
  height: 2.4rem;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ $disabled }) => ($disabled ? "#B1B8C4" : "#b1b8c4")};
  border-radius: 0.4rem;
  background: ${({ $disabled }) => ($disabled ? "#CBD0D8" : "#fff")};
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  ${poppins_body_sm_medium}
  color: #2a2f37;
  line-height: 1;
  pointer-events: ${({ $disabled }) => ($disabled ? "none" : "auto")};

  ${({ $disabled }) =>
    $disabled &&
    css`
      svg path {
        fill: #96a1b0;
      }
    `}

  &:hover {
    background: #f0f2f4;
    border-color: #96a1b0;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.12),
      0px 2px 4px 0px rgba(0, 0, 0, 0.16);
  }

  &:active {
    background: #e5e7eb;
    border-color: #7c899c;
    box-shadow: inset 0px 0px 8px 0px rgba(0, 0, 0, 0.06),
      inset 0px 8px 16px 0px rgba(0, 0, 0, 0.08);
  }
`;

export const ZoomBadge = styled.div`
  box-sizing: border-box;
  width: 5.6rem;
  height: 2.4rem;
  padding: 0 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #b1b8c4;
  border-radius: 0.4rem;
  background: #fff;
  ${poppins_body_sm_medium}
  color: #2a2f37;
  cursor: default;
`;

export const ZoomBadgeText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
`;

export const ZoomBadgeTooltip = styled.div<{
  $rect: { top: number; bottom: number; left: number };
}>`
  position: fixed;
  top: ${({ $rect }) => $rect.bottom + 2}px;
  left: ${({ $rect }) => $rect.left}px;
  z-index: 1000;
  padding: 0.4rem;
  border-radius: var(--Border-Radius-4, 0.4rem);
  border: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);
  background: var(--Color-Common-Bg-Primary, #fff);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16), 0 0 2px 0 rgba(0, 0, 0, 0.12);
  ${ptSerif_body_sm_regular}
  color: #2a2f37;
  white-space: nowrap;
  pointer-events: none;
`;
